module.exports = __webpack_public_path__ + "static/img/23090110C1.0aa37ae8.png";